var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"conversations__empty"},[_c('span',{staticClass:"conversations__empty-message"},[_vm._v(_vm._s(this.text))])])}
var staticRenderFns = []

export { render, staticRenderFns }